module.exports = __webpack_public_path__ + "img/blue-en-mobile.e7c6551e.jpg";